import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'qaroni-expiration-days-preview',
  templateUrl: './expiration-days-preview.component.html',
  styleUrls: ['./expiration-days-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ExpirationDaysPreviewComponent {
  readonly day = input<number>(0);

  get isUrgent(): boolean {
    return this.day() <= 7;
  }

  get isWarning(): boolean {
    return this.day() > 7 && this.day() <= 30;
  }
}
